import { Location, Price, TextCard } from 'views/styled/ItemCardStyles'
import { Bid, BidStatus } from 'modules/domain/bid/types'
import { formatQuantity } from 'modules/utils/numbers/formatQuantity'
import { getPriceWithType } from 'modules/domain/bid/utils'
import { getMainParameter } from 'modules/utils/helpers'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

const BlockTextCard = styled(TextCard)`
  display: block;
`

type Props = {
  bid: Bid
}

export const BidCardInfo = ({ bid }: Props) => {
  const { t } = useTranslation()

  const mainParam = getMainParameter(bid.parameters)

  return (
    <>
      <div>
        <BlockTextCard thumbnail>
          {bid.product.title}, {bid.season && `${bid.season.name}`}
        </BlockTextCard>
        <TextCard thumbnail={bid.status === BidStatus.potential}>{formatQuantity(bid.quantity)}</TextCard>
        {bid.status != BidStatus.potential && (
          <>
            {mainParam && <TextCard>, {mainParam}</TextCard>}
            {', '}
            <Price>{getPriceWithType(bid, t)}</Price>
          </>
        )}
      </div>
      <Location>{bid.address.address}</Location>
    </>
  )
}
